import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "material-icons is-md" }
const _hoisted_2 = {
  key: 0,
  class: "settings section"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("header", { class: "settings__header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Settings")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Account", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons is-md" }, "logout", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Log out", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "byline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("button", {
      key: _ctx.settingsVisible ? 'close' : 'settings',
      class: "settings-toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.settingsVisible = !_ctx.settingsVisible))
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.settingsVisible ? 'close' : 'settings'), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.settingsVisible ? 'Close' : 'Settings'), 1)
    ])),
    _createElementVNode("span", null, [
      _createVNode(_Transition, {
        name: "settings-menu",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.settingsVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.subMenu === '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _hoisted_5,
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                            type: "button"
                          }, _hoisted_8)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.subMenu)))
                    ])),
                _createElementVNode("footer", _hoisted_10, " All rights reserved © Scrolldex 2022 (v" + _toDisplayString(_ctx.version) + ") ", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 64))
}